import { FunctionComponent } from 'react';
import qs from 'qs';
import GoogleLogo from './LoginMethodLogos/Google';
import GitHubLogo from './LoginMethodLogos/GitHub';
import GitLabLogo from './LoginMethodLogos/GitLab';
import BitBucketLogo from './LoginMethodLogos/BitBucket';
import { AuthContextState } from '../context/AuthContext';
import Button from '../../generic/Button';
import { hardRedirectTo } from '../../../utils';

//  TODO: does this belong here, or someplace better?
type LoginMethod = 'google' | 'github' | 'gitlab' | 'bitbucket';

const loginURLMap: Record<LoginMethod, string> = {
  google: '/account/google',
  github: '/account/github_login',
  gitlab: '/account/gitlab_login',
  bitbucket: '/account/bitbucket_cloud_login',
};

//  Redirect to the login method URL when that button is clicked.
const getButtonOnClick = (method: LoginMethod, inviteToken?: string) => {
  return () => hardRedirectTo(`${loginURLMap[method]}?${qs.stringify({ inviteToken })}`);
};

//  Returns the text which makes up the "divider"
function getDividerText(hidePasswordInput: boolean, isLoginPage: boolean): string {
  const orText = hidePasswordInput
    ? ''
    : 'or';
  const signInOrUp = isLoginPage
    ? 'sign in'
    : 'sign up';
  return `${orText} ${signInOrUp} with:`;
}

//  Helper to return the button's a11y text
function getTitleText(page: AuthContextState['page'], method: string): string {
  return page === 'login'
    ? `Sign in using ${method}`
    : `Sign up using ${method}`;
}

type AuthFormLoginMethodButtonProps = {
  title: string;
  onClick: () => void;
};

/**
 * Sub-component for each individual login method button.
 *
 * @param {onClick} - Click handler for the button.
 */
const AuthFormLoginMethodButton: FunctionComponent<AuthFormLoginMethodButtonProps> = ({
  title,
  children,
  onClick,
}) => (
  <li className="fossa-auth__login-methods__method">
    <Button
      type="secondary"
      size="large"
      title={title}
      onClick={onClick}
    >
      {children}
    </Button>
  </li>
);

type FormLoginMethodsProps = Pick<AuthContextState, 'loginMethods' | 'hidePasswordInput' | 'page' | 'inviteToken'>;

/**
 * Renders the OAuth LoginMethod buttons.
 */
const AuthFormLoginMethods = ({
  loginMethods,
  hidePasswordInput,
  page,
  inviteToken,
}: FormLoginMethodsProps) => {
  const hasLoginMethods = Object.values(loginMethods).some((isFlagEnabled: boolean |  undefined) => isFlagEnabled);
  return (
    <>
      {hasLoginMethods && (
        <>
          <div className="fossa-auth__login-methods__divider">
            {getDividerText(hidePasswordInput, page === 'login')}
          </div>
          <ul className="fossa-auth__login-methods">
            <AuthFormLoginMethodButton
              title={getTitleText(page, 'Google')}
              onClick={getButtonOnClick('google', inviteToken)}
            >
              <GoogleLogo />
            </AuthFormLoginMethodButton>
            <AuthFormLoginMethodButton
              title={getTitleText(page, 'GitHub')}
              onClick={getButtonOnClick('github', inviteToken)}
            >
              <GitHubLogo />
            </AuthFormLoginMethodButton>
            <AuthFormLoginMethodButton
              title={getTitleText(page, 'GitLab')}
              onClick={getButtonOnClick('gitlab', inviteToken)}
            >
              <GitLabLogo />
            </AuthFormLoginMethodButton>
            <AuthFormLoginMethodButton
              title={getTitleText(page, 'Bitbucket')}
              onClick={getButtonOnClick('bitbucket', inviteToken)}
            >
              <BitBucketLogo />
            </AuthFormLoginMethodButton>
          </ul>
        </>
      )}
    </>
  );
};

export default AuthFormLoginMethods;
